export default __webpack_public_path__ + "media/images/icons_fc/dossierbleu-647afd138bc58990f6097afad74b87de.png";